import React from 'react';
import { Link } from 'react-router-dom';
import { company, routes } from '../../models/content';
import V2AddressText from './V2AddressText';

export default function V2CtaDark() {
  return (
    <div className="cta-dark">
      <div className="inner">
        <div>
          <span className="kicker">Get in Touch</span>
          <h3>
            Revitalising <span className="it">resilient</span> businesses.
            <br />
            Catalysing <span className="it">exponential</span> growth.
          </h3>
          <div className="actions">
            <Link to={routes.contact} className="btn btn-light btn-lg">
              Get in Touch →
            </Link>
          </div>
        </div>
        <div className="addr">
          <div className="kicker">Address</div>
          <div className="body">
            <V2AddressText />
          </div>
          <div className="links">
            <a href={company.phoneHref}>📞 {company.phoneDisplay}</a>
            <a href={company.emailHref}>✉ {company.emailDisplay}</a>
          </div>
        </div>
      </div>
    </div>
  );
}

